export default __webpack_public_path__ + "static/media/Checkout.37595cbb.svg";